import { useRoutes } from 'react-router-dom'
import MainRoutes from './MainRoutes'
import AuthenticationRoutes from './AuthenticationRoutes'
import NotFound from 'src/views/404/NotFound'

export default function ThemeRoutes() {
    return useRoutes([AuthenticationRoutes, MainRoutes, { path: '*', element: <NotFound /> }])
}
